import React from "react";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import { customFilter, jobSearchGetOptionLabel, jobSearchIsOptionEqualToValue, handleJobSearchChange, renderOption } from "./helpers";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { cacheUtils } from "../../../../../../../../..";
import { CacheTypes } from "@utils/cache/interfaces";
import { useAppSelector } from "@store/hooks";

const name = "FuzzySearch"

type Props = {
    parent: string
    inputRef: any;
}

const FuzzySearch: React.FC<Props> = ({ parent, inputRef }) => {
    const problemComboJobSearch = useAppSelector(({ ui }) => ui.ProblemComboJobSearch)

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent, problemComboJobSearch })
    return (
        (<Grid
            size={{
                xs: 12,
                sm: 12
            }}>
            <Autocomplete
                id="combo-box-job-types-search"
                autoHighlight={true}
                filterOptions={customFilter}
                options={cacheUtils.getCache<CacheTypes.JobTypeOptions>("JobTypesOptions")!.sort((a, b) => String(a!.tradeDescription)!.localeCompare(String(b!.tradeDescription))) || []}
                getOptionLabel={jobSearchGetOptionLabel}
                isOptionEqualToValue={jobSearchIsOptionEqualToValue}
                renderInput={(params) => <TextField {...params} label="Jobs search" variant="outlined" />}
                onChange={(e, v) => handleJobSearchChange(e, v, inputRef)}
                groupBy={(option) => option.tradeDescription}
                renderOption={renderOption}
                value={problemComboJobSearch}
            />
        </Grid>)
    );
}

export default React.memo(FuzzySearch)